module.exports = __webpack_public_path__ + "img/logoFinalMKLite.48fb439e.png";